"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse2004ToJSON = exports.InlineResponse2004FromJSONTyped = exports.InlineResponse2004FromJSON = void 0;
function InlineResponse2004FromJSON(json) {
    return InlineResponse2004FromJSONTyped(json, false);
}
exports.InlineResponse2004FromJSON = InlineResponse2004FromJSON;
function InlineResponse2004FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'loginUrl': json['loginUrl'],
    };
}
exports.InlineResponse2004FromJSONTyped = InlineResponse2004FromJSONTyped;
function InlineResponse2004ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'loginUrl': value.loginUrl,
    };
}
exports.InlineResponse2004ToJSON = InlineResponse2004ToJSON;
